// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"ContentSection_contentSection__Ob3y_","title":"ContentSection_title__4ceqB","content":"ContentSection_content__WQpz8"};